import { css } from "styled-components";
import { breakpoints } from "../responsive/breakpoints";

export const containerWidths = {
  SM: 540,
  MD: 720,
  LG: 960,
  XL: 1140
};

type Size = "xs" | "sm" | "md" | "lg" | "xl" | "";

const makeCols = (size: Size = "") => {
  const loopRange = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const suffix = size ? `-${size}` : size;
  return `
    .col${suffix} {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
    .col${suffix}-auto {
      flex: 0 0 auto;
      width: auto;
      max-width: none;
    }
    ${loopRange.map(x => `.col${suffix}-${x} {flex: 0 0 ${(x / 12) * 100}%; max-width: ${(x / 12) * 100}%;}`).join("")}
  `;
};

const makeOrders = (size: Size = "") => {
  const loopRange = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const suffix = size ? `-${size}` : size;
  return `
    .order${suffix}-first {
      order: -1;
    }
    .order${suffix}-last {
      order: 13;
    }
    ${loopRange.map(x => `.order${suffix}-${x} {order: ${x};}`).join("")}
  `;
};

const makeOffsets = (size: Size = "") => {
  const loopRange = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const suffix = size ? `-${size}` : size;
  return loopRange.map(x => `.offset${suffix}-${x} {margin-left: ${(x / 12) * 100}%;}`).join("");
};

export const grid = css`
  .container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  @media (min-width: ${breakpoints.SM_MIN}px) {
    .container {
      max-width: ${containerWidths.SM}px;
    }
  }
  @media (min-width: ${breakpoints.MD_MIN}px) {
    .container {
      max-width: ${containerWidths.MD}px;
    }
  }
  @media (min-width: ${breakpoints.LG_MIN}px) {
    .container {
      max-width: ${containerWidths.LG}px;
    }
  }
  @media (min-width: ${breakpoints.XL_MIN}px) {
    .container {
      max-width: ${containerWidths.XL}px;
    }
  }
  .container-fluid {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .iframeRow {
    display: flex;
    flex-wrap: wrap;
    margin-right: 50px;
    margin-left: 50px;
  }
  .no-gutters {
    margin-right: 0;
    margin-left: 0;
  }
  .no-gutters > .col,
  .no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
  .col,
  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col-auto,
  .col-lg,
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-auto,
  .col-md,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-auto,
  .col-sm,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-auto,
  .col-xl,
  .col-xl-1,
  .col-xl-2,
  .col-xl-3,
  .col-xl-4,
  .col-xl-5,
  .col-xl-6,
  .col-xl-7,
  .col-xl-8,
  .col-xl-9,
  .col-xl-10,
  .col-xl-11,
  .col-xl-12,
  .col-xl-auto {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }
  ${makeCols()};
  ${makeOrders()};
  ${makeOffsets()};
  @media (min-width: ${breakpoints.SM_MIN}px) {
    ${makeCols("sm")};
    ${makeOrders("sm")};
    ${makeOffsets("sm")};
  }
  @media (min-width: ${breakpoints.MD_MIN}px) {
    ${makeCols("md")};
    ${makeOrders("md")};
    ${makeOffsets("md")};
  }
  @media (min-width: ${breakpoints.LG_MIN}px) {
    ${makeCols("lg")};
    ${makeOrders("lg")};
    ${makeOffsets("lg")};
  }
  @media (min-width: ${breakpoints.XL_MIN}px) {
    ${makeCols("xl")};
    ${makeOrders("xl")};
    ${makeOffsets("xl")};
  }
`;
